<template>
    <div class="obrazec obnova ovoj" id="html">
        <div class="glava">
            <div class="levi-logo">
              <img src='~@/assets/ikc.png'/>
            </div>
            <div class="desni-info">
                <p>Pivola 8, SI2311 Hoče</p>
                <p>Tel.: (02) 613 08 31, -32</p>
                <p>info@ikc-um.si</p>
                <p><a href="www.ikc-um.si">www.ikc-um.si</a></p>
            </div>
        </div>
        
        <div id="vsebina">
          
      
        
            <div class="sekcija imeobrazca">
                <h1>Seznam certificiranih proizvodov po certifikatu št: {{ certifikat.stevilkacertifikata }}, z dne {{ (certifikat.datumizdaje).toLocaleDateString('SL-si') }}</h1>
                <h6></h6>
            </div> 
			<div class="noga-izven">
        		<div class="stevilka-strani" >E_Obr. 6.11, rev.00, 20. 4. 2023, stran </div>
        		<div class="info">Pivola 8, SI-2311 Hoče, telefon: + 386 (0)2 6130831, -32, e-mail: info@ikc-um.si, www.ikc-um.si</div>
      		</div>

            <form @submit.prevent="handleSubmit" class="k-form">
            
                <div class="sekcija podatki">
                    <h1>
						{{ nosilec }}
					</h1>
					
                </div>

				<div class="kulture">
                    <div>
						<table class="tabela">
							<colgroup>
    							<col style="width:40%">
    							<col style="width:30%">
								<col style="width:15%">
								<col style="width:15%">
  							</colgroup>
							<tr>
								<th>certificiran pridelek, proizvod</th>
								<th>vsebina po šifrantu</th>
								<th>vsebina certifikata</th>
								<th>Status</th>
							</tr>
						</table>
					</div>	
					<div>
						<table class="tabela">
							<colgroup>
    							<col style="width:40%">
    							<col style="width:30%">
								<col style="width:15%">
								<col style="width:15%">
  							</colgroup>
							<tr v-for="(kultura,i) in kulture">
								<td>{{ kultura.naziv_interno?kultura.naziv_interno:kultura.naziv }}</td>
								<td>{{ kultura.naziv }}</td>
								<td>{{ kultura.certifikat }}</td>
								<td>{{ kultura.statuspridelkanaziv }}</td>
							</tr>
							<tr v-for="(zival,i) in zivali">
								<td>{{ zival.naziv_interno?zival.naziv_interno:zival.naziv }}</td>
								<td>{{ zival.naziv }}</td>
								<td>{{ zival.certifikat }}</td>
								<td>{{ zival.statuspridelkanaziv }}</td>
							</tr>
							<tr v-for="(proizvod,i) in proizvodi">
								<td>{{ proizvod.naziv_interno?proizvod.naziv_interno:proizvod.naziv }}</td>
								<td>{{ proizvod.naziv }}</td>
								<td>{{ proizvod.certifikat }}</td>
								<td>{{ proizvod.statuspridelkanaziv }}</td>
							
							</tr>
						
						</table>
						
                    </div>
                    

                </div>

				<div class="noga">
					<div class="datum">
	           Datum: 
			</div>
			<div class="podpis">
				Podpis

			</div>
			
         		</div>
     
				
				

				
            </form>
        </div>
        
    </div>
</template>
<style scoped>

  h1,h2,h3{
    font-size:5mm;
    line-size:5mm;
  }

@media print {
.sekcija {
 
        }
}

.datum,.podpis {
	margin-right: 10rem;
	font-size: 1rem;
}
.tabela-kultura-wrapper {
	column-count:2;
}
.tabela-proizvod-wrapper {
	column-count:3;
}
.tabela{
	width: 100%;
	table-layout: fixed;
}
.tabela td,.tabela,.tabela th {
	
	border: 1px solid green;
	border-collapse: collapse;
	padding:3px;
}

 label,textarea{
    break-inside: avoid !important;
     
 }
.glava{
    
    display:    flex ;
    flex-direction:     row ;
    justify-content:    space-between  ;

}
.levi-logo  {
  
}  

.levi-logo img{
    height: 2cm;
  
}
.desni-info {
  
}

.desni-info p{
    
    margin: 0;
    font-size:  0.4cm;
    line-height:   0.4cm;
    text-align:     right   ;
}



 .noga {

    display:    flex ;
    flex-direction:     row ;
    justify-content:    end;
	margin-top:2rem;
}

 .stevilka-strani:after{
  content: counter(page) " od " counter(pages);
}

.noga-izven{
  position:  running(nogaRunning);
  font-size: 3mm ;
  line-height:5mm;
 
}

@page {

    margin-top: 10mm;
  margin-bottom: 20mm;
  margin-left: 10mm;
  margin-right: 10mm;
size: A4 portrait;

@bottom-center {
  content:  element(nogaRunning);
  vertical-align: center;
}

@left-middle {
  content:  element(leviStolpecRunning);
} 
}

label.k-form-field{
    font-weight:    bold;
    font-size:  0.8em;
    line-height:    0.8em;
    margin-top:2mm;
    margin-bottom:1mm;
}
.posta input:nth-child(1){
    flex-basis: 15%;
    margin-right: 3mm;

}
h6{
    font-size: 0.7em;
}

.sekcija {
    margin-top:2mm;
    border:   1px solid green;
    padding: 2mm;
}
.posebnosti .seznamkategorij
{
    border-bottom:  1px solid green;
}
.izjava ul{
    list-style-type: disc;
margin-top: 3mm;
margin-bottom: 3mm;
margin-left: 0;
margin-right: 0;
padding-left: 10mm;
}
.vrsticapodpisa div {
    flex-basis: 50%;
}
</style>

<script>



import { mapState, mapActions,mapMutations } from 'vuex'
import { Previewer,registerHandlers,Handler  } from 'pagedjs';

class RepeatingTableHeaders extends Handler {
 /* constructor(chunker, polisher, caller) {
    super(chunker, polisher, caller);
  }

  afterPageLayout(pageElement, page, breakToken, chunker) {
    // Find all split table elements
    let tables = pageElement.querySelectorAll("table[data-split-from]");

    tables.forEach((table) => {
      // Get the reference UUID of the node
      let ref = table.dataset.ref;
      // Find the node in the original source
      let sourceTable = chunker.source.querySelector("[data-ref='" + ref + "']");
      // Find if there is a header
      let header = sourceTable.querySelector("thead");
      if (header) {
        // Clone the header element
        let clonedHeader = header.cloneNode(true);
        // Insert the header at the start of the split table
        table.insertBefore(clonedHeader, table.firstChild);
      }
    });

  }
  old but working*/ 
    constructor(chunker, polisher, caller) {
        super(chunker, polisher, caller);
        this.splitTablesRefs = [];
    }

    afterPageLayout(pageElement, page, breakToken, chunker) {
        this.chunker = chunker;
        this.splitTablesRefs = [];

        if (breakToken) {
            const node = breakToken.node;
            const tables = this.findAllAncestors(node, "table");
            if (node.tagName === "TABLE") {
                tables.push(node);
            }

            if (tables.length > 0) {
                this.splitTablesRefs = tables.map(t => t.dataset.ref);

                //checks if split inside thead and if so, set breakToken to next sibling element
                let thead = node.tagName === "THEAD" ? node : this.findFirstAncestor(node, "thead");
                if (thead) {
                    let lastTheadNode = thead.hasChildNodes() ? thead.lastChild : thead;
                    breakToken.node = this.nodeAfter(lastTheadNode, chunker.source);
                }

                this.hideEmptyTables(pageElement, node);
            }
        }
    }

    hideEmptyTables(pageElement, breakTokenNode) {
        this.splitTablesRefs.forEach(ref => {
            let table = pageElement.querySelector("[data-ref='" + ref + "']");
            if (table) {
                let sourceBody = table.querySelector("tbody > tr");
                if (!sourceBody || this.refEquals(sourceBody.firstElementChild, breakTokenNode)) {
                    table.style.visibility = "hidden";
                    table.style.position = "absolute";
                    let lineSpacer = table.nextSibling;
                    if (lineSpacer) {
                        lineSpacer.style.visibility = "hidden";
                        lineSpacer.style.position = "absolute";
                    }
                }
            }
        });
    }

    refEquals(a, b) {
        return a && a.dataset && b && b.dataset && a.dataset.ref === b.dataset.ref;
    }

    findFirstAncestor(element, selector) {
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                return element.parentNode;
            }
            element = element.parentNode;
        }
        return null;
    }

    findAllAncestors(element, selector) {
        const ancestors = [];
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                ancestors.unshift(element.parentNode);
            }
            element = element.parentNode;
        }
        return ancestors;
    }

    // The addition of repeating Table Headers is done here because this hook is triggered before overflow handling
    layout(rendered, layout) {
        this.splitTablesRefs.forEach(ref => {
            const renderedTable = rendered.querySelector("[data-ref='" + ref + "']");
            if (renderedTable) {
                // this event can be triggered multiple times
                // added a flag repeated-headers to control when table headers already repeated in current page.
                if (!renderedTable.getAttribute("repeated-headers")) {
                    const sourceTable = this.chunker.source.querySelector("[data-ref='" + ref + "']");
                    this.repeatColgroup(sourceTable, renderedTable);
                    this.repeatTHead(sourceTable, renderedTable);
                    renderedTable.setAttribute("repeated-headers", true);
                }
            }
        });
    }

    repeatColgroup(sourceTable, renderedTable) {
        let colgroup = sourceTable.querySelectorAll("colgroup");
        let firstChild = renderedTable.firstChild;
        colgroup.forEach((colgroup) => {
            let clonedColgroup = colgroup.cloneNode(true);
            renderedTable.insertBefore(clonedColgroup, firstChild);
        });
    }

    repeatTHead(sourceTable, renderedTable) {
        let thead = sourceTable.querySelector("thead");
        if (thead) {
            let clonedThead = thead.cloneNode(true);
            renderedTable.insertBefore(clonedThead, renderedTable.firstChild);
        }
    }

    // the functions below are from pagedjs utils/dom.js
    nodeAfter(node, limiter) {
        if (limiter && node === limiter) {
            return;
        }
        let significantNode = this.nextSignificantNode(node);
        if (significantNode) {
            return significantNode;
        }
        if (node.parentNode) {
            while ((node = node.parentNode)) {
                if (limiter && node === limiter) {
                    return;
                }
                significantNode = this.nextSignificantNode(node);
                if (significantNode) {
                    return significantNode;
                }
            }
        }
    }

    nextSignificantNode(sib) {
        while ((sib = sib.nextSibling)) {
            if (!this.isIgnorable(sib)) return sib;
        }
        return null;
    }

    isIgnorable(node) {
        return (node.nodeType === 8) || // A comment node
            ((node.nodeType === 3) && this.isAllWhitespace(node)); // a text node, all whitespace
    }

    isAllWhitespace(node) {
        return !(/[^\t\n\r ]/.test(node.textContent));
    }

}

//registerHandlers(RepeatingTableHeaders);




import Vue from 'vue';

export default {
    props: ["pridelovalecid","sezona","shema"],
   data() {
        return {
            posebnosti:[{id:0,naziv:"sočasna ekološka in neekološka pridelava/reja/predelava"},{id:1,naziv:"gobe"},{id:2,naziv:"vzgoja sadik"},{id:3,naziv:"samonikle rastline"},{id:4,naziv:"čebele"},{id:5,naziv:"pridelava semena"}],
            blagovneznamke:[{id:1,naziv:"DEMETER"},{id:2,naziv:"V-Label"},{id:3,naziv:"brez GSO"}],
            tretjeosebe:[{id:1,naziv:"Samo eko predelava"},{id:2,naziv:"samo konv. predelava"},{id:3,naziv:"eko in konv predelava"},],
            kulture:[],zivali:[],proizvodi:[],certifikat:{},
            vrsta:[],
            status:[],
            pridelava:{},
            statuskategorije:[],
            kategorije:[],
			kontrolnastevilka:"",
            nosilec:"test",
            ooseba:"",
            naslov:"",
            posta:"",
            postnastevilka:"",
            kmgmid:"",
            telefon:"",
            mobitel:"",
            email:"",
            spletnastran:"",
            naslovkmg:"",
            postakmg:"",
            postnastevilkakmg:"",
            dopolnilnadejavnost:"",
            davcnastevilka:"",
            nazivdopolnilnadejavnost:""
        }
    },
    computed:{
      /*...mapState({certifikat(state) {
      
          return state.certifikat.certifikat;
        }}),*/
       ...mapState('pridelava', ['pridelovalec']),
       
        
    
    },
     methods: {

        
        ...mapActions('pridelava',['loadOne']),
        ...mapActions('proizvod', ['load']),
		...mapActions({nalozicertifikate:"certifikat/load"}),
        
		handleSubmit(e){

          e.preventDefault();
        },
        print() {
                let paged = new Previewer();
                paged.preview();
        },
        naloziPodatke (){

         var thisComp=this;
		
		

        this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(p=>{

                           thisComp.kmgmid=p.kmgmid;

							let kontakt=p.kontakt.find(k=>k.vloga=="nosilec kmg");
      						if(!kontakt)
      						kontakt=p.kontakt.find(k=>k.glavni);
      						if(!kontakt)
      						kontakt=p.kontakt[0];

                            thisComp.nosilec=kontakt.naziv;
                         
                            thisComp.naslov=kontakt.naslov;
                            thisComp.posta=kontakt.posta;
                            thisComp.postnastevilka=kontakt.postnastevilka;
                            thisComp.telefon=p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.telefon.join(";");
                            thisComp.email=kontakt.email.join(", ");
                            thisComp.mobitel=kontakt.telefon.join(", ");
                            thisComp.naslovkmg=p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.naslov;
                            thisComp.postakmg=p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.posta
                            thisComp.postnastevilkakmg  =p.kontakt.find(i=>i.vloga=="kmetija (kmg)")?.postnastevilka;
                            thisComp.davcnastevilka =p.davcnastevilka  ;

							

                          let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
                            if (pridelava) {
                            //console.log("nastavim status kategorije");
                            //console.log(pridelava.kategorije);
                           // thisComp.pridelava  =pridelava  ;
							thisComp.kontrolnastevilka=pridelava.kontrolnaStevilka;

                            }
						
						var pdata=[

                        this.load({sezona:(this.dataSezona.sezona),pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled,vrsta:"kultura"}).then(

                                data=>{
                                    console.log("loading kulture!")
                                    thisComp.kulture=JSON.parse(JSON.stringify(data.filter(s=>s.certifikat!="/").sort((a,b)=>a.naziv.localeCompare(b.naziv))))
                                    
                                },
                                error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
                        ),
                        this.load({sezona:(this.dataSezona.sezona),pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled,vrsta:"zival"}).then(

                                data=>{
                                    console.log("loading kulture!")
                                    thisComp.zivali=JSON.parse(JSON.stringify(data.sort((a,b)=>a.naziv.localeCompare(b.naziv))))
                                    
                                },
                                error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
                        ),
                        this.load({sezona:(this.dataSezona.sezona),pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled,vrsta:"proizvod"}).then(

                                data=>{
                                    console.log("loading kulture!")
                                    thisComp.proizvodi=JSON.parse(JSON.stringify(data.sort((a,b)=>a.naziv.localeCompare(b.naziv))))
                                    
                                },
                                error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
                        ),
						
						this.nalozicertifikate({sezona:this.dataSezona.sezona,strankaid:this.pridelovalecid,makeEditable:!this.editDisabled,shema:this.shema}).then(
						data=>{
							console.log("certifikati")
							
							thisComp.certifikat=data.filter(c=>c.veljaven).sort((a,b)=>{
                                var razlika=(a.datumveljavnosti-b.datumveljavnosti);
                                if(razlika==0)
                                    return a.datumizdaje-b.datumizdaje
                                else
                                    return razlika;

                            }).shift();
                            if(!thisComp.certifikat)
                                thisComp.certifikat={stevilkacertifikata:0,datumizdaje:new Date()}
							console.log(thisComp.certifikat)
						},
						error=>{console.log("tukaj sem!!!");this.dataLoading=false;})
					]

					Promise.all(pdata).then(v=>{
						let paged = new Previewer();
      			        paged.preview();
					})


                            

                }) ;
      
        


       // });
        //});

        //});

        
    }                
    

      },
    created()
  {
    
    if(!this.sezona)
        this.dataSezona={sezona:2022};
    else
      this.dataSezona={sezona:this.sezona};

     this.naloziPodatke();
     //window.addEventListener('beforeprint',this.print);
	
},

  mounted(){
   
 }
}
</script>